import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import theme from "./utils/theme";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
// import { loadClearbit } from "./loadClearBit";
import * as Sentry from "@sentry/react";
import {withSentryProfiler} from "./sentry/sentry";

const AppWithProfiler = withSentryProfiler(App);


// loadClearbit();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StyledEngineProvider injectFirst>
    <DndProvider backend={HTML5Backend}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <BrowserRouter>
            <AppWithProfiler />
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </DndProvider>
  </StyledEngineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
